export default __webpack_public_path__ + "media/images/flags/ne-5545a526eb7c4ce590dae74ff88c5740.png";